<template>
  <div class="image" :class="classes">
    <img
      class="is-rounded"
      :src="avatar"
      :alt="alt"
      @error="
        (e) => {
          loadDefault(e)
        }
      "
    />
  </div>
</template>

<script>
import defaultUserAvatar from '~/assets/images/default-avatar.png'

export default {
  props: ['src', 'classes', 'alt', 'default'],
  computed: {
    avatar() {
      return this.src || defaultUserAvatar
    },
  },
  methods: {
    loadDefault(e) {
      e.target.src = this.default || defaultUserAvatar
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin min-max($value) {
  min-width: $value;
  min-height: $value;
  max-width: $value;
  max-height: $value;
}

::v-deep.image {
  border-radius: 50%;
  position: relative;
  min-width: 40px;
  min-height: 40px;
  &.size-24 {
    @include min-max(24px);
  }
  &.size-32 {
    @include min-max(32px);
  }
  &.size-40 {
    @include min-max(40px);
  }
  &.size-140 {
    @include min-max(140px);
  }
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    top: 0;
    left: 0;
    right: 0;
  }
}
</style>
